import { isExpireNowFromNumber } from '@/utils/date';
/**
 * 通用打开窗口模式相关
 */
export var E_Stage;
(function (E_Stage) {
    E_Stage["None"] = "none";
    E_Stage["Edit"] = "edit";
    E_Stage["Add"] = "add";
    E_Stage["Clone"] = "clone";
    E_Stage["Preview"] = "preview";
    E_Stage["Readonly"] = "readonly";
})(E_Stage || (E_Stage = {}));
export var E_UserRole;
(function (E_UserRole) {
    E_UserRole[E_UserRole["General"] = 0] = "General";
    E_UserRole[E_UserRole["Admin"] = 1] = "Admin";
})(E_UserRole || (E_UserRole = {}));
// 需要从后端动态获取, 这里只是用于定义
export var E_UserStatus;
(function (E_UserStatus) {
    E_UserStatus["ACTIVE"] = "ACTIVE";
    E_UserStatus["FAKE_ACTIVE"] = "FAKE_ACTIVE";
    E_UserStatus["INACTIVE"] = "INACTIVE";
    E_UserStatus["PENDING"] = "PENDING";
    E_UserStatus["DISABLED"] = "DISABLED";
    E_UserStatus["BLOCKED"] = "BLOCKED";
    E_UserStatus["EXPIRED"] = "EXPIRED";
    E_UserStatus["NO_STATUS"] = "NO_STATUS";
    E_UserStatus["BLACK"] = "BLACK";
})(E_UserStatus || (E_UserStatus = {}));
(function (E_UserStatus) {
    /**
     * 显示禁用
     */
    function showBlock(value) {
        return [E_UserStatus.ACTIVE, E_UserStatus.FAKE_ACTIVE].includes(value);
    }
    E_UserStatus.showBlock = showBlock;
    /**
     * 显示解禁
     */
    function showUnblock(value) {
        return [E_UserStatus.BLOCKED].includes(value);
    }
    E_UserStatus.showUnblock = showUnblock;
    /**
     * 显示停用
     */
    function showDisabled(value) {
        return [
            E_UserStatus.INACTIVE,
            E_UserStatus.PENDING,
            E_UserStatus.ACTIVE,
            E_UserStatus.FAKE_ACTIVE,
            E_UserStatus.BLOCKED
        ].includes(value);
    }
    E_UserStatus.showDisabled = showDisabled;
    /**
     * 显示修改密码
     * 1.当用户没有登录过智慧芽 lastLogin 如果有这个字段表示登录过
     * 2.当用户所在企业授权可以修改密码时
     *  2.1 授权时间未过期，如果过期也不显示 true 表示没有过期  false 过期
     */
    function showPassword(changePassword, lastLogin, end) {
        const expired = isExpireNowFromNumber(end);
        return (changePassword && !expired) || !lastLogin;
    }
    E_UserStatus.showPassword = showPassword;
})(E_UserStatus || (E_UserStatus = {}));
// 需要从后端动态获取, 这里只是用于定义
export var E_AccountType;
(function (E_AccountType) {
    /**
     * 付费privilege + 未过期
     */
    E_AccountType["STANDARD"] = "STANDARD";
    /**
     * 合作推广
     */
    E_AccountType["COOPERATIVE"] = "COOPERATIVE";
    /**
     * 试用
     */
    E_AccountType["TRIAL"] = "TRIAL";
    /**
     * 断约 付费privilege + 已过期
     */
    E_AccountType["NOT_RENEW"] = "NOT_RENEW";
    /**
     * 免费 过期试用 或者没有任何privilege
     */
    E_AccountType["FREE"] = "FREE";
    /**
     * 内部
     */
    E_AccountType["INTERNAL"] = "INTERNAL";
})(E_AccountType || (E_AccountType = {}));
(function (E_AccountType) {
    /**
     * 可修改密码
    */
    function showPassword(value) {
        return E_AccountType.TRIAL === value;
    }
    E_AccountType.showPassword = showPassword;
})(E_AccountType || (E_AccountType = {}));
export var E_Language;
(function (E_Language) {
    E_Language["en_US"] = "en_US";
    E_Language["zh_CN"] = "zh_CN";
    E_Language["zh_TW"] = "zh_TW";
    E_Language["ja_JP"] = "ja_JP";
})(E_Language || (E_Language = {}));
export var E_Lang;
(function (E_Lang) {
    E_Lang["cn"] = "cn";
    E_Lang["en"] = "en";
    E_Lang["tw"] = "tw";
    E_Lang["jp"] = "jp";
})(E_Lang || (E_Lang = {}));
export var E_Region;
(function (E_Region) {
    E_Region["CN"] = "CN";
    E_Region["EU"] = "EU";
    E_Region["US"] = "US";
})(E_Region || (E_Region = {}));
export var E_CompanyArea;
(function (E_CompanyArea) {
    E_CompanyArea["EAST"] = "east";
    E_CompanyArea["WEST"] = "west";
})(E_CompanyArea || (E_CompanyArea = {}));
